// Wires up every .lead-form__form on the page to inc/ajax/lead-form.php.
export function initLeadForms() {
	document.querySelectorAll('.lead-form__form').forEach((form) => {
		form.addEventListener('submit', async (e) => {
			e.preventDefault();

			const statusEl = form.querySelector('.lead-form__status');
			const submitBtn = form.querySelector('.lead-form__submit');
			statusEl.textContent = '';
			statusEl.className = 'lead-form__status';
			submitBtn.disabled = true;

			try {
				const formData = new FormData(form);
				formData.set('nonce', window.igsData ? window.igsData.nonce : formData.get('nonce'));

				const response = await fetch(window.igsData ? window.igsData.ajaxUrl : '/wp-admin/admin-ajax.php', {
					method: 'POST',
					body: formData,
				});
				const result = await response.json();

				if (result.success) {
					statusEl.textContent = result.data.message;
					statusEl.classList.add('is-success');
					form.reset();
				} else {
					const errors = result.data && result.data.errors ? Object.values(result.data.errors) : ['Something went wrong.'];
					statusEl.textContent = errors.join(' ');
					statusEl.classList.add('is-error');
				}
			} catch (err) {
				statusEl.textContent = 'Network error — please try again.';
				statusEl.classList.add('is-error');
			} finally {
				submitBtn.disabled = false;
			}
		});
	});
}
